<!--
Requires Collapse Plugin from bootsrap-vue in the app:

import { CollapsePlugin } from 'bootstrap-vue'
Vue.use(CollapsePlugin)
-->

<template>
  <div class="accordion-element">
    <div class="accordion-trigger" role="tab">
      <a href="#"
         v-b-toggle="id"
         tabindex="0"
         role="button"
         class="sw--font-size-22 sw-dms__link--inherit-color sw--padding-vert-4 sw-grid-flex sw-grid-flex--align-center"
         v-on:click.prevent>
        <slot name="trigger"></slot>
        <span class="icon-chevron-down sw--margin-left-auto"></span>
        <span class="icon-chevron-up sw--margin-left-auto"></span>
      </a>
    </div>

    <b-collapse :id="id" :accordion="group" role="tabpanel" :visible="expanded">
      <slot name="target"></slot>
    </b-collapse>
  </div>
</template>

<script>
  export default {
    name: "Accordion",
    props: {
      id: {
        required: true,
        type: String
      },
      group: {
        required: true,
        type: String
      },
      expanded: {
        required: false,
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";
  @import "~bootstrap/scss/mixins";

  @import "~bootstrap/scss/transitions";

  .accordion-element {
    border-bottom: solid 1px #dad8da;
  }

  .collapsed > .icon-chevron-up,
  :not(.collapsed) > .icon-chevron-down {
    display: none;
  }
</style>
